
export const TRANSLATION_URL = 'https://erv-ecloud-dev.equeo.info/rest/v1/translations'
export const GEOCONFIG_URL = 'https://erv-geoconf-dev.equeo.info/config/'
export const GEOCOUNTRY_URL = 'https://erv-geoserver-dev.equeo.info/api/v1/poi/countries'
export const POI_URL = 'https://erv-geoserver-dev.equeo.info/api/v1/poi/short'
export const SEARCH_URL = 'https://erv-geoserver-dev.equeo.info/api/v1/poi/search'

// export const TRANSLATION_URL = 'https://erv-ecloud-prod.equeo.info/rest/v1/translations'
// export const GEOCONFIG_URL = 'https://erv-geoconf-prod.equeo.info/config/'
// export const GEOCOUNTRY_URL = 'https://erv-geoserver-prod.equeo.info/api/v1/poi/countries'
// export const POI_URL = 'https://erv-geoserver-prod.equeo.info/api/v1/poi/short'
// export const SEARCH_URL = 'https://erv-geoserver-prod.equeo.info/api/v1/poi/search'



// WEBPACK FOOTER //
// ./src/constants/Constants.js